import styled from 'styled-components';

import { dangerHighlightColor, warnHighlightColor } from '../../../lib/theme';

// The backdrop and the field MUST share these exact text metrics, or the
// highlight rectangles drift from the characters they mark.
const sharedText = `
  margin: 0;
  padding: 8px;
  font: 14px/1.5 'Quicksand', sans-serif;
  letter-spacing: normal;
  box-sizing: border-box;
`;

// Owns the field's border/radius/background so the input and its backdrop can
// share one padded content box (border here, not on the transparent input).
export const HighlightWrapper = styled.div<{ $disabled?: boolean }>`
  position: relative;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: ${(p) => (p.$disabled ? '#e0e4e8' : '#fafcfe')};

  &:focus-within {
    border-color: #bdd739;
  }
`;

export const HighlightBackdrop = styled.div<{ $multiline?: boolean }>`
  ${sharedText}
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  color: transparent;
  white-space: ${(p) => (p.$multiline ? 'pre-wrap' : 'pre')};
  overflow-wrap: ${(p) => (p.$multiline ? 'break-word' : 'normal')};
`;

// Zero padding is load-bearing: any horizontal padding on the mark changes the
// token's advance width and shifts every following character out of alignment.
export const TokenMark = styled.mark`
  padding: 0;
  border-radius: 2px;
  background: ${dangerHighlightColor};

  &[data-issue='missing-fallback'] {
    background: ${warnHighlightColor};
  }
`;

const fieldBase = `
  ${sharedText}
  position: relative;
  display: block;
  width: 100%;
  border: none;
  background: transparent;
  color: #222;

  &:focus { outline: none; }
  &::placeholder { color: #9aa0a6; }
`;

export const HighlightInput = styled.input`
  ${fieldBase}
`;

export const HighlightTextArea = styled.textarea`
  ${fieldBase}
  resize: vertical;
  white-space: pre-wrap;
  overflow-wrap: break-word;
`;
